import controller from './response.controller';
import template from './response.view.html';

let ResponseComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default ResponseComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/response/response.component.js
 **/